import { DefineComponent, FunctionalComponent } from "vue";
import { Key } from "../../types/skyward/svg";
import Svg from "../core/svg";

interface ButtonProps
{
    svgName: Key;
    spanClasses?: string[];
    title?: string;
    disabled?: boolean;
    svgClasses?: string[];
    svgShowHoverEffect?: boolean;
    svgColor?: string;
    svgOnRight?: boolean;
    clickFunc?: (e: MouseEvent) => void;
    onMouseover?: (e: MouseEvent) => void;
    onMouseout?: (e: MouseEvent) => void;
    role?: string;
};

const Button: FunctionalComponent<ButtonProps> = function vButton(props: ButtonProps, context)
{
    const span = context.slots.default && <span class={["anchorText", props.svgOnRight ? "textBefore" : "textAfter", "buttonText", ...(props.spanClasses ?? [])]}>{context.slots.default()}</span>;

    return (
        <a
            role={props.role ?? "button"}
            onClick={handleButtonClick}
            class={{ button: true, chromeless: true, svgAnchor: true, "ui-disabled": props.disabled === true }}
            href="javascript:void(0)"
            title={props.title}
            {...context.attrs}
        >
            {props.svgOnRight && span}
            <Svg
                name={props.svgName}
                svgClasses={[props.svgOnRight ? "svgTextBefore" : "svgTextAfter", "buttonSvg", ...(props.svgClasses ?? [])]}
                tabindex="-1"
                onMouseover={props.onMouseover}
                onMouseout={props.onMouseout}
                showHoverEffect={props.svgShowHoverEffect ?? true}
                style={props.svgColor ? { fill: props.svgColor } : undefined}
            />
            {!props.svgOnRight && span}
        </a>
    );

    function handleButtonClick(event: MouseEvent)
    {
        if (!props.disabled)
        {
            props.clickFunc?.(event);
        }
    }
};

Button.props = ["svgName", "spanClasses", "title", "disabled", "svgClasses", "svgShowHoverEffect", "svgColor", "svgOnRight", "clickFunc"];
export default Button as unknown as DefineComponent<ButtonProps, JSX.Element>;
